"use client";

import { route as cartRoute } from "@faire/web-api/routes/cart";
import { removeLocaleFromUrl } from "@faire/web/ui/routing/util";
import React, { Suspense, useMemo } from "react";
import { matchPath, useLocation } from "react-router-dom";

import {
  EventListener,
  IEventHandlerProps,
} from "@faire/retailer/components/Notifications/EventListener";
import {
  AddToCart,
  AddToCartNotificationFinished,
  IAddToCartEvent,
} from "@faire/retailer/events";

import { LazyAddedToBag } from "./LazyAddedToBag";
import { useAddedToBag } from "./useAddedToBag";

/**
 * Component listens for add to cart event, and lazy loads AddedToBag
 * component upon the first event publication, then updates child components
 * notification data on each subsequent event publication.
 */

export const AddedToBagListener: React.FC = () => {
  const { shouldIgnore } = useAddedToBag();
  const { pathname: pathnameWithMaybeLocale } = useLocation();
  const pathname = useMemo(
    () => removeLocaleFromUrl(pathnameWithMaybeLocale),
    [pathnameWithMaybeLocale]
  );
  if (matchPath(pathname, cartRoute)) {
    return null;
  }

  return (
    <EventListener<IAddToCartEvent>
      event={AddToCart}
      shouldIgnoreEvent={shouldIgnore}
      eventFinish={AddToCartNotificationFinished}
      eventHandlerElement={eventHandlerElement}
    />
  );
};

const eventHandlerElement = (props: IEventHandlerProps<IAddToCartEvent>) => (
  <Suspense fallback={null}>
    <LazyAddedToBag {...props} />
  </Suspense>
);
